// https://www.w3.org/TR/webdriver1/#cookies

// Cookie 就是一个存储在浏览器里的一个文本文件
// 通常由服务端生成，发送到客户端
// 不占用服务器资源
// HTTP Header : Set-Cookie: name=xxx; domain=xxx.com

// 同一个域名下的所有请求，都会携带 Cookie
// 过量的 Cookie 会带来巨大的性能浪费

// cookie 大小限制在 4KB
// 复杂场景不够用

export function useCookie(
  name: string,
  options?: {
    value?: any;
    days?: number;
    path?: string;
    domain?: string;
    secure?: boolean;
  }
) {
  let value = options?.value || "";

  if (!value) {
    const c = `; ${document.cookie}`
      .split(`; ${name}=`)
      .pop()
      ?.split(";")
      .shift();
    if (c) {
      value = decodeURIComponent(c);
    }
  }

  const get = () => value;

  const set = (v: any) => {
    value = v;
    if (value) {
      const domain = options?.domain ? "; domain=" + options.domain : "";
      const path = options?.path ? "; path=" + options.path : "";
      const secureString = options?.secure == true ? "; secure" : "";
      let cookie =
        name + "=" + encodeURIComponent(value) + domain + path + secureString;
      if (options?.days) {
        const expires =
          "; expires=" +
          new Date(Date.now() + options.days * 864e5).toUTCString();
        cookie += expires;
      }
      document.cookie = cookie;
    }
  };

  set(value);

  return {
    get,
    set
  };
}

export function clearCookies() {
  // document.cookie
  //   .split(";")
  //   .forEach(
  //     (cookie) =>
  //       (document.cookie = cookie
  //         .replace(/^ +/, "")
  //         .replace(/=.\*/, `=;expires=${new Date(0).toUTCString()};path=/`))
  //   );
  const cookies = document.cookie.split("; ");
  for (let c = 0; c < cookies.length; c++) {
    const d = window.location.hostname.split(".");
    while (d.length > 0) {
      const cookieBase =
        encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
        "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
        d.join(".") +
        " ;path=";
      const p = location.pathname.split("/");
      document.cookie = cookieBase + "/";
      while (p.length > 0) {
        document.cookie = cookieBase + p.join("/");
        p.pop();
      }
      d.shift();
    }
  }
}
